module.exports = __webpack_public_path__ + "img/zillow-active.5f950f0.png";